import { render } from "./MainCockpit.vue?vue&type=template&id=5f23ff41"
import script from "./MainCockpit.vue?vue&type=script&lang=js"
export * from "./MainCockpit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__